export type LabCategoryKey = 'all' | 'news' | 'guide' | 'beanstory' | 'events';

export interface LabArticleV2 {
  _id: string;
  title: string;
  titleEn?: string;
  slug: string;
  excerpt?: string;
  category: 'news' | 'guide' | 'beanstory' | 'events';
  featuredImage?: string;
  author?: string;
  publishedAt?: string;
  status: 'draft' | 'published' | 'archived';
  isFeatured?: boolean;
  createdAt: string;
}

export const LAB_CATEGORIES: Record<Exclude<LabCategoryKey, 'all'>, { zh: string; en: string }> = {
  news: { zh: '最新消息', en: 'News' },
  guide: { zh: '沖煮指南', en: 'Brewing Guide' },
  beanstory: { zh: '豆單故事', en: 'Bean Story' },
  events: { zh: '活動紀錄', en: 'Events' },
};
